const url          = new URL(window.location.href);
const params       = new URLSearchParams(url.search);
const category     = params.get('c');
const headerIn     = document.querySelector('.headerUserInitails');
const filterExpand = document.querySelector('.filterExpand');
const filterL      = document.querySelectorAll('.filterList input');
const bodyClasses  = document.querySelector('body').classList;
const titleWrapper = document.querySelector('.rolling-headline-wrapper');
const tabWrapper   = document.querySelector('.tabPaneWrapper');
const nav          = document.querySelector('.productTab .nav-tabs');

let moreLink = null;

function isMobile() {
  return window.innerWidth <= 768;
}

//Registration Functions
function mxConfirmPassword(){
    let p = document.getElementById('newCustomerPassword').value;
    let cp = document.getElementById('newCustomerPasswordConfirmation').value;
    if(p == cp){
      mxCheckPassword();
      document.getElementById("cpassword-error").classList.add('d-none');
    }else{
      document.getElementById("cpassword-error").classList.remove('d-none');
    }
  }
function mxCheckPassword(){
    let p = document.getElementById('newCustomerPassword').value;
    let cp = document.getElementById('newCustomerPasswordConfirmation').value;
    let myInput = document.getElementById("newCustomerPassword"),
        letter = document.getElementById("letter"),
        capital = document.getElementById("capital"),
        number = document.getElementById("number"),
        symbol = document.getElementById("symbol"),
        length = document.getElementById("length"),
        lowerCaseLetters = /[a-z]/g,
        upperCaseLetters = /[A-Z]/g,
        numbers = /[0-9]/g,
        symbols = /[!@#$%^&*-.,;+]/g;
  
    if(myInput.value.match(lowerCaseLetters)) {
      letter.classList.remove("invalid");
      letter.classList.add("valid");
    } else {
      letter.classList.remove("valid");
      letter.classList.add("invalid");
    }
    if(myInput.value.match(upperCaseLetters)) {
      capital.classList.remove("invalid");
      capital.classList.add("valid");
    } else {
      capital.classList.remove("valid");
      capital.classList.add("invalid");
    }
    if(myInput.value.match(numbers)) {
      number.classList.remove("invalid");
      number.classList.add("valid");
    } else {
      number.classList.remove("valid");
      number.classList.add("invalid");
    }
    if(myInput.value.match(symbols)) {
      symbol.classList.remove("invalid");
      symbol.classList.add("valid");
    } else {
      symbol.classList.remove("valid");
      symbol.classList.add("invalid");
    }
    if(myInput.value.length >= 8) {
      length.classList.remove("invalid");
      length.classList.add("valid");
    } else {
      length.classList.remove("valid");
      length.classList.add("invalid");
    }
    if(myInput.value.length >= 8 && myInput.value.match(symbols) && myInput.value.match(numbers) && myInput.value.match(upperCaseLetters) && myInput.value.match(lowerCaseLetters) && p == cp) {
      document.querySelector('#max').removeAttribute("disabled", "disabled");
    }else{
      document.querySelector('#max').setAttribute("disabled", "disabled");
    }
  }
function setupRegistration(){
  if(document.querySelector('#newCustomerPassword')){
    let password = document.querySelector('#newCustomerPassword');
    let confirmPassword = document.querySelector('#newCustomerPasswordConfirmation');

    password.onfocus = () => document.getElementById("password-error").classList.remove('d-none');
    password.onblur  = () => document.getElementById("password-error").classList.add('d-none');

    ['click','change','blur','input'].forEach( function(evt){ 
      password.addEventListener(evt, mxConfirmPassword, false);
      password.addEventListener(evt, mxCheckPassword, false);
      confirmPassword.addEventListener(evt, mxConfirmPassword, false);
    });
  }
  setTimeout(function() {
    if (document.querySelector('.frcp-cf-form--registration')) {
      document.querySelectorAll('option').forEach(option => {
        if (option.textContent.trim() === 'Krankenversicherung') {
          option.selected = true;
          option.disabled = true;
          option.textContent = '-';
        }
      });
      document.querySelector('[title="Registriere dich im Auftrag eines Unternehmens"]').onchange = function() {
        if(this.checked){
          document.querySelector('.form-control[title="Tax ID"]').required = true;
          document.querySelector('.form-control[title="Name der Firma"]').required = true;
          document.querySelector('.form-control[title="Tax ID"]').parentElement.classList.add("frcp-cf--required");
          document.querySelector('.form-control[title="Name der Firma"]').parentElement.classList.add("frcp-cf--required");
          document.querySelector('.form-control[title="Name der Firma"]').parentElement.style.display = 'inline-block';
          document.querySelector('.form-control[title="Tax ID"]').parentElement.style.display = 'inline-block';
        }else{
          document.querySelector('.form-control[title="Name der Firma"]').required = false;
          document.querySelector('.form-control[title="Tax ID"]').required = false;
          document.querySelector('.form-control[title="Tax ID"]').parentElement.classList.remove("frcp-cf--required");
          document.querySelector('.form-control[title="Name der Firma"]').parentElement.classList.remove("frcp-cf--required");
          document.querySelector('.form-control[title="Name der Firma"]').parentElement.style.display = 'none';
          document.querySelector('.form-control[title="Tax ID"]').parentElement.style.display = 'none';
        }    
      };
      document.querySelectorAll('.frcp-cf').forEach(function (item, index) {
        if(!item.querySelector('input[type=checkbox]')){
          item.classList.remove('frcp-cf'); 
          item.classList.add('form-group'); 
        }
      });
      document.querySelectorAll('.frcp-cf__control,.vti__input,.vue-tel-input').forEach(function (item, index) {
        if(!item.parentElement.querySelector('input[type=checkbox]')){
          item.classList.remove('frcp-cf__control'); 
          item.classList.add('form-control'); 
        }
      });
      document.querySelector('.frcp-cf-btn').classList.add('btn', 'btn-theme');
      document.querySelectorAll('.frcp-cf__label').forEach(function (item, index) {
        if(!item.parentElement.querySelector('input[type=checkbox]')){
          let parent = item.parentElement.querySelector('.vue-tel-input') ? item.parentElement.querySelector('.vue-tel-input') : item.parentElement;
          parent.appendChild(item);
          item.classList.remove('frcp-cf__label'); 
          item.classList.add('label--hidden'); 
        }
      });
    }
  }, 1200);
}

//Product Template Functions
function maxTitle(){
    const packageOriginalPrice = getProductUnitPrice();
    if (!packageOriginalPrice) return '';
    const priceTiers = [
      { quantity: '1', percent: 1, discount: '' },
      { quantity: 'ab 10', percent: .95, discount: '5% Ersparnis' },
      { quantity: 'ab 25', percent: .93, discount: '7% Ersparnis' },
      { quantity: 'ab 50', percent: .9, discount: '10% Ersparnis' },
      { quantity: 'ab 100', percent: .85, discount: '15% Ersparnis' },
      { quantity: '250+', percent: .8, discount: '20% Ersparnis' }
    ];

    let Pcontent = '<div class="pricingTable"><h5 class="tableTitle">Anzahl</h5>';

    priceTiers.forEach(function(tier) {
      const unitPrice = packageOriginalPrice * tier.percent;
      const formattedPrice = unitPrice.toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      Pcontent += '<div class="tableRow"><div class="quantityNo">' + tier.quantity + '</div><div class="unitPrice premium">' + formattedPrice + ' €/Stück</div><div class="discountValue">' + tier.discount + '</div></div>';
    });

    Pcontent += '</div>';
    return Pcontent;
  }
function getProductPriceElement() {
  return document.querySelector('[id^="mxProductPrice-"]');
}
function getProductUnitPrice() {
  const priceElement = getProductPriceElement();
  if (!priceElement) return null;

  const price = priceElement.getAttribute('content') || priceElement.textContent;
  const normalizedPrice = price.replace(/[^\d,.]/g, '').replace(',', '.');
  const unitPrice = parseFloat(normalizedPrice);

  return isNaN(unitPrice) ? null : unitPrice;
}
function productTemplateQuantityOffer() {
    if(document.querySelector('body').classList.contains('template-product')){
      setTimeout(function() {
        var mxQuantity = document.querySelector('#Quantity');
        let packageOriginalPrice = getProductUnitPrice();
        if (!packageOriginalPrice || !mxQuantity) return;
        let pricePercent, discountPercent = 0, Quantity = parseInt(document.querySelector('#Quantity').value);
        Quantity = isNaN(Quantity) ? 1 : Quantity; 
        if(Quantity < 10){ 
          pricePercent   = 1;
          document.querySelector('#perPerson').classList.remove("tDLT");
        }else document.querySelector('#perPerson').classList.add("tDLT");
        if(Quantity > 9) pricePercent   = .95, discountPercent = 5;
        if(Quantity > 24) pricePercent  = .93, discountPercent = 7;
        if(Quantity > 49) pricePercent  = .9,  discountPercent = 10;
        if(Quantity > 99) pricePercent  = .85, discountPercent = 15;
        if(Quantity > 249) pricePercent = .8,  discountPercent = 20;
        let newPrice = parseFloat(packageOriginalPrice * pricePercent).toFixed(2);
        let totalPrice = parseFloat(newPrice * Quantity).toFixed(2);
        
        document.querySelector('#changablePrice').textContent =  parseFloat(newPrice).toLocaleString('de', {minimumFractionDigits: 2}) + ' €';
        document.querySelector('#mxTotalPrice').textContent   =  parseFloat(totalPrice).toLocaleString('de', {minimumFractionDigits: 2}) + ' €';
        if(discountPercent != 0) document.querySelector('#discountPercent').textContent = '-'+discountPercent+'% Ersparnis';
        else if(typeof(discountPercent) != "undefined") document.querySelector('#discountPercent').textContent = '';
      }, 200);
    }
  }
function setupProductTemp() {
  productTemplateQuantityOffer();
  var someElement = getProductPriceElement();
  var mxQuantity = document.querySelector('#Quantity');
  if (!someElement || !mxQuantity) return;
  if(document.getElementById('info') && typeof bootstrap !== 'undefined') new bootstrap.Tooltip(document.getElementById('info'),{html: true,title: maxTitle});
  document.querySelectorAll('.js-qty__adjust').forEach(el => el.addEventListener('click', productTemplateQuantityOffer));
  const packageOriginalPrice = getProductUnitPrice();
  if (!packageOriginalPrice) return;
  document.querySelector('#mxTotalPrice').textContent = document.querySelector('#changablePrice').textContent = packageOriginalPrice.toLocaleString('de', {minimumFractionDigits: 2}) + ' €';
  someElement.textContent = packageOriginalPrice.toLocaleString('de', {minimumFractionDigits: 2}) + ' €';
  document.querySelector('#Quantity').addEventListener("input",productTemplateQuantityOffer);
}
document.addEventListener('DOMContentLoaded', () => {
  if (headerIn){
    let name = document.getElementById('userFullName').textContent;
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
    let initials = [...name.matchAll(rgx)] || [];
    headerIn.textContent = document.getElementById('initials').textContent =(
      (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();
  }
  if(titleWrapper){
    const viewport = titleWrapper.querySelector('.rolling-viewport');
    const list = titleWrapper.querySelector('.rolling-list'); // updated selector
    if (!viewport || !list) return;

    let items = Array.from(list.querySelectorAll('.rolling-item'));
    if (!items.length) return;

    const ORIGINAL_COUNT = items.length;
    const INTERVAL = parseInt(titleWrapper.dataset.interval || 2800, 10); 
    const TRANS_MS = parseInt(titleWrapper.dataset.transition || 600, 10);

    let index = 0;
    let timer = null;
    let paused = false;

    const clone = items[0].cloneNode(true);
    list.appendChild(clone);

    items = Array.from(list.querySelectorAll('.rolling-item'));

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateHeight).catch(() => setTimeout(updateHeight, 80));
    } else {
        setTimeout(updateHeight, 80);
    }
    setActiveByIndex(0);
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      list.style.transition = 'none';
      setActiveByIndex(0);
      return;
    }
    
    timer = setInterval(gotoNext, INTERVAL);

    //Moving Section Title Functions
    function updateHeight() {
      if(!items || !list) return;
      const h = items[0].offsetHeight || 0;
      viewport.style.height = h + 'px';
      list.style.transition = `transform ${TRANS_MS}ms cubic-bezier(.2,.9,.2,1)`;
      list.style.transform = `translateY(-${index * h}px)`;
    }
    function setActiveByIndex(i) {
      if(!items || !ORIGINAL_COUNT) return;
      const activeIdx = i % ORIGINAL_COUNT;
      for (let j = 0; j < ORIGINAL_COUNT; j++) {
        items[j].classList.toggle('is-active', j === activeIdx);
      }
    }
    function gotoNext() {
      if (paused || !items || !list) return;
      index++;
      const h = items[0].offsetHeight || 0;
      list.style.transition = `transform ${TRANS_MS}ms cubic-bezier(.2,.9,.2,1)`;
      list.style.transform = `translateY(-${index * h}px)`;
      setActiveByIndex(index);
                
      setTimeout(() => {
        if (index >= ORIGINAL_COUNT) {
          list.style.transition = 'none';
          index = 0;
          list.style.transform = `translateY(0px)`;
          setActiveByIndex(index);
          requestAnimationFrame(() => {
            list.style.transition = `transform ${TRANS_MS}ms cubic-bezier(.2,.9,.2,1)`;
          });
        }
      }, TRANS_MS);
    }
    
    titleWrapper.addEventListener('mouseenter', () => { paused = true; });
    titleWrapper.addEventListener('mouseleave', () => { paused = false; });
    titleWrapper.addEventListener('focusin', () => { paused = true; });
    titleWrapper.addEventListener('focusout', () => { paused = false; });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        list.style.transition = 'none';
        index = index % ORIGINAL_COUNT;
        updateHeight();
        resizeTimer = setTimeout(() => {
        list.style.transition = `transform ${TRANS_MS}ms cubic-bezier(.2,.9,.2,1)`;
        }, 80);
    });
  }
  if(tabWrapper){
    document.addEventListener('click', function (e) {
      const navItem = e.target.closest('.nav-link');
      if (!navItem) return; // Not a nav item

      // Scroll to the content wrapper
      const offset = wrapper.getBoundingClientRect().top + window.scrollY - 70;  
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    });
  }
  if (bodyClasses.contains('template-customers-register')) setupRegistration();
  if (bodyClasses.contains('template-product'))            setupProductTemp();
  const consentCheckbox = document.querySelector('.bew-consent input[type="checkbox"]');
  
  if (consentCheckbox) {
    consentCheckbox.checked = true;
  }
});
